import { createFileRoute } from '@tanstack/react-router';
import { PlansPage } from '~/components/pages/PlansPage';
import { plansMeta } from '~/content/pricing';
import { pageHeadMeta } from '~/lib/seo';
import pricingStylesHref from '~/styles/pricing.css?url';

export const Route = createFileRoute('/plans')({
  head: () =>
    pageHeadMeta({
      title: plansMeta.title,
      description: plansMeta.description,
      path: '/plans',
      stylesheets: [pricingStylesHref],
    }),
  component: PlansPage,
});
